var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/toggle/star_outline_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/toggle/star_outline_24px_2",
    d: "M18.9369 6.40013L13.2816 5.90938L11.0733 0.709827C10.676 -0.236609 9.32059 -0.236609 8.92332 0.709827L6.71497 5.92107L1.07141 6.40013C0.0431825 6.48192 -0.377456 7.7672 0.405399 8.4449L4.69357 12.1605L3.40829 17.6756C3.1746 18.6804 4.26125 19.475 5.14926 18.9375L9.99829 16.0164L14.8473 18.9492C15.7353 19.4867 16.822 18.6921 16.5883 17.6873L15.303 12.1605L19.5912 8.4449C20.374 7.7672 19.9651 6.48192 18.9369 6.40013Z",
    fill: "#555893"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star_outline.09fb8616.svg";
export { ForwardRef as ReactComponent };